var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 288,
    viewBox: "0 0 336 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9160_2236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -48,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    transform: "translate(0 -48)",
    fill: "url(#paint0_radial_9160_2236)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9160_2236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 47.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 47.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 71.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 95.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 119.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 143.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 167.5,
    stroke: "#E4E7EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9160_2236",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circles.0f2f4c63ba1c12e2d3a8177bf520f708.svg";